import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    sizeVariant: deprecatedProp(PropTypes.oneOf([
        'standard',
        'large',
        'extra-large'
    ]), 'Please use size props instead'),
    size: PropTypes.oneOf([
        'standard',
        'large',
        'extra-large'
    ]),
    centered: PropTypes.bool,
    inline: PropTypes.bool
};
const Preloader = createComponent({
    displayName: 'Preloader',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const { sizeVariant ='standard' , size =sizeVariant , centered , inline  } = props;
            const classNameSet = new Set([
                'swan-preloader-graphic'
            ]);
            if (size !== 'standard') classNameSet.add(`swan-preloader-graphic-${size}`);
            if (centered) classNameSet.add('swan-preloader-graphic-center');
            if (inline) classNameSet.add('swan-preloader-graphic-inline');
            return classNameSet;
        },
        processProps (props) {
            return _object_spread_props(_object_spread({}, props), {
                'aria-live': 'polite',
                role: 'status',
                as: props.as || props.component || (props.inline ? 'span' : 'div')
            });
        }
    }
});
Preloader.defaultProps = {
    inline: false,
    centered: false
};

export { Preloader, propTypes };
